export default __webpack_public_path__ + "static/media/useronclick.a6d9ab1e.svg";